// @owners { team: patient-fulfillment }
import { BillableTypeMap } from '@alto/billing_api/types/v1';
import {
  type OrderPricingParams,
  type PrescriptionPricing,
} from '@alto/scriptdash/alto/pricing/patients/v3/pricing_endpoint';
import { type PaymentBreakdown } from '@alto/scriptdash/alto/pricing/types/v3/payment_breakdown';
import { type PriceBreakdown } from '@alto/scriptdash/alto/pricing/types/v3/price_breakdown';
import { type Order } from '~shared/features/checkout/types';

export const makeFetchOrderPricingOrderParam = ({
  items = [],
  selected_payment_types,
  tip_amount,
  address_id,
  date,
  deliver_after,
  deliver_before,
  on_demand_delivery_price,
}: Order): OrderPricingParams => {
  const param: OrderPricingParams = {
    items: items.map((item) => ({ ...item, selected_price_type: null })),
    selected_payment_types,
    tip_amount,
    scheduling_params: undefined,
    on_demand_delivery_price,
  };
  if (date && address_id) {
    param.scheduling_params = {
      address_id,
      date,
      deliver_after,
      deliver_before,
    };
  }
  return param;
};

export const convertPaymentBreakdownToLegacyBreakdown = (paymentBreakdown: PaymentBreakdown): PriceBreakdown => {
  const { cash_price, insurance_payers_paid, remainder_paid, total, pending_progyny_coverage, payers } =
    paymentBreakdown;

  const couponPaid = payers.reduce((accum, payer) => {
    if (payer.billable_type === BillableTypeMap.COUPON || payer.billable_type === BillableTypeMap.REBATE) {
      accum += parseFloat(payer.amount_covered);
    }
    return accum;
  }, 0);
  const dealPaid = payers.reduce((accum, payer) => {
    if (payer.billable_type === BillableTypeMap.DEAL) {
      accum += parseFloat(payer.amount_covered);
    }
    return accum;
  }, 0);

  return {
    cash_price,
    insurance_paid: insurance_payers_paid,
    pending_progyny_coverage,
    coupon_paid: couponPaid + remainder_paid,
    deal_paid: dealPaid,
    total,
  };
};

export const backfillLegacyBreakdownInItemPricing = (itemPricing: PrescriptionPricing[]) => {
  return itemPricing.map((pricing) => {
    const backfilledPrices = pricing.prices.map((priceOption) => {
      if (!priceOption.payment_breakdown) return priceOption;

      return {
        ...priceOption,
        price_breakdown: convertPaymentBreakdownToLegacyBreakdown(priceOption.payment_breakdown),
      };
    });

    return {
      ...pricing,
      prices: backfilledPrices,
    };
  });
};
